import React from 'react';
import "./style.css";
const Terms = () => {
    return (
        <div className='Container'>
            <h2>Terms and Conditions</h2>
            <div className='privacy'>
                <p>Welcome to Ganpati Traders  . You agree to be bound by these Terms and Conditions by accessing or using this website. Please read them carefully, as they outline your rights and responsibilities as a site user. If you do not agree with any part of these Terms, you must not use our website.</p>
                <h4>User Responsibilities</h4>

                <ul id='ulTag'>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Accurate Information:</strong> You are responsible for providing correct and up-to-date information when creating an account or purchasing on our website. False or misleading information may result in account suspension or order cancellation.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Compliance:</strong> You agree to use our website in compliance with all applicable laws and regulations. Any unauthorized or unlawful use of the website is strictly prohibited.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Account Security:</strong> You are solely responsible for maintaining the confidentiality of your account credentials. Any activity conducted under your account will be your responsibility.
                    </li>
                </ul>
                <h4>Payment Terms</h4>

                <ul id='ulTag'>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Accepted Payment Methods:</strong> We accept various forms of payment, including credit cards, debit cards, and digital wallets. All payment transactions are processed securely.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Payment Authorization:</strong> By completing a purchase, you authorize us to charge the payment method provided for the total amount, including taxes and shipping fees, as displayed during checkout.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Pricing Policy:</strong> Prices on our website are subject to change without prior notice. While we strive to ensure accurate pricing, errors may occur, and we reserve the right to cancel orders if the pricing is incorrect.
                    </li>
                </ul>
                <h4>Shipping and Delivery</h4>

                <ul id='ulTag'>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Delivery Timelines:</strong> We aim to deliver your orders within the estimated timelines provided at checkout. However, delays may occur due to unforeseen circumstances, such as courier issues or external factors.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Shipping Address:</strong> You are responsible for providing a complete and accurate shipping address. Delivery may be delayed or unsuccessful if the address is incorrect or incomplete.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Loss or Damage:</strong> We take utmost care in packaging your items but are not liable for loss or damage during transit. Any issues should be reported immediately upon receiving the shipment.
                    </li>
                </ul>
                <h4>Returns and Refunds</h4>

                <ul id='ulTag'>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Return Eligibility:</strong> Items are eligible for return only if they are defective, damaged, or incorrect. The item must be returned in its original condition with all packaging and tags intact within 7 days of delivery.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Refund Policy:</strong> Refunds will be issued only after the returned item is inspected and approved. The original payment method will be credited within 7-10 business days.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Return Process:</strong> To initiate a return, don't hesitate to contact our customer support team at <a href="mailto:info@ganpatitraders.online">info@ganpatitraders.online</a> with your order details and the reason for the return.
                    </li>
                </ul>
                <h4>Intellectual Property</h4>

                <ul id='ulTag'>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Ownership:</strong> All content on this website, including text, images, graphics, and trademarks, is the intellectual property of Ganpati Traders and is protected by applicable copyright and trademark laws.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Restricted Use:</strong> You may not copy, reproduce, distribute, or use our content without written permission. Unauthorized use may result in legal action.
                    </li>
                </ul>
                <h4>Limitations of Liability</h4>

                <ul id='ulTag'>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>No Warranty:</strong> While we strive to provide accurate product descriptions and reliable services, we do not warrant that the website will be error-free or that the products will meet your expectations.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Limited Liability:</strong> Ganpati Traders and its affiliates shall not be held liable for any direct, indirect, incidental, or consequential damages arising from the use of our website or products purchased through it.
                    </li>
                </ul>
                <h4>Dispute Resolution</h4>

                <ul id='ulTag'>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Governing Law:</strong> These Terms and Conditions are governed by the laws of India.
                    </li>
                   
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Jurisdiction:</strong> If arbitration is not pursued, disputes may be brought before the courts of India.
                    </li>
                </ul>
                <h4>Privacy Policy</h4>

                <ul id='ulTag'>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Data Collection:</strong> We collect and process personal data using our privacy policy. This includes information during account creation, order placement, and website usage.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Data Security:</strong> We implement industry-standard measures to protect your data from unauthorized access. However, we cannot guarantee absolute security.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Third-Party Sharing:</strong> We do not sell or share your data with third parties without your consent, except as required to complete your transactions or comply with legal obligations.
                    </li>
                </ul>

                <h4>Modifications to Terms</h4>
                <p>We reserve the right to modify or update these Terms and Conditions anytime. Changes will be posted on this page, and the revised Terms will take effect immediately. It is your responsibility to review these Terms regularly.</p>
                <h4>Contact Us</h4>
                <p>If you have any questions or concerns regarding these Terms and Conditions, please feel free to contact us at:</p>
                <ul style={{ textDecoration: 'none', listStyle: 'none' }}>
                    <li style={{ fontSize: '18px' }}><strong>Email:</strong> <a href='mailto:info@ganpatitraders.online'>info@ganpatitraders.online</a></li>
                    <li style={{ fontSize: '18px' }}><strong>Customer Support Center:</strong> Available 24/7 via our website.</li>
                </ul>

                <p>Thank you for choosing Ganpati Traders for your shopping needs! Your satisfaction is our priority.</p>
            </div>
        </div>
    )
}

export default Terms;